webpackJsonp([55096043974599],{

/***/ 531:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mitchell Kansas Tesla Blog","author":"Ryan Mitchell"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2018-06-24-kian-fun-fun-fun/index.md absPath of file >>> MarkdownRemark","html":"<p>On wednesday June 20th me and “THE DAUGHTER” had a water balloon fight with a lot of water balloons. Shortly after we played with fireworks (poppers). After that we had to clean up the mess we made. We used a broom and a leaf blower. We had a lot of fun with those activities.</p>","frontmatter":{"title":"Fun Fun Fun!","date":"June 24, 2018","author":"kian"}}},"pathContext":{"slug":"/2018-06-24-kian-fun-fun-fun/","previous":{"fields":{"slug":"/2018-06-19-kian-fish/"},"frontmatter":{"title":"The Best Fishing Day","author":"kian"}},"next":{"fields":{"slug":"/2018-06-26-mitch-charging-costs/"},"frontmatter":{"title":"Charging costs","author":"mitch"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---2018-06-24-kian-fun-fun-fun-9673c7326f2c10dc7de1.js